import { TranscriptionApi } from '../api/transcription'

export const { useGetTranscriptionQuery, useUpdateTranscriptionInfoMutation, useTranscribeFromFileMutation } = TranscriptionApi
